import React from 'react';
import dayjs from 'dayjs';
import { Link } from 'gatsby';
import css from './Footer.module.css';
import EuroMomoInvert from '../images/euromomo-invert.svg';

const Footer = ({ node, list }) => {
	return (
		<footer className={css.root}>
			<Link to="/" className={css.logo}>
				<EuroMomoInvert height={45} />
			</Link>
			<div>
				<Link to="/about-us/contact/">Contact</Link>
				<span>All rights reserved ©{dayjs().year()}</span>
			</div>
		</footer>
	);
};

export default Footer;
